var _excluded = ["size", "title", "children", "viewBox", "aria-hidden"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import * as style from './icon-base.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var LARGE_VIEWBOX = '0 0 32 32';
export var REGULAR_VIEWBOX = '0 0 24 24';
export var SMALL_VIEWBOX = '0 0 18 18';
export var SizeClass;
(function (SizeClass) {
  SizeClass["SMALL_CLASS"] = "small";
  SizeClass["REGULAR_CLASS"] = "regular";
  SizeClass["CUSTOM_CLASS"] = "custom";
})(SizeClass || (SizeClass = {}));
var IconBase = _ref => {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? SizeClass.REGULAR_CLASS : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    children = _ref.children,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? REGULAR_VIEWBOX : _ref$viewBox,
    _ref$ariaHidden = _ref['aria-hidden'],
    ariaHidden = _ref$ariaHidden === void 0 ? 'true' : _ref$ariaHidden,
    props = _objectWithoutProperties(_ref, _excluded);
  var className = props.className ? "domain-icon ".concat(props.className) : 'domain-icon';
  return ___EmotionJSX("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: viewBox,
    "aria-hidden": ariaHidden,
    css: style.domainIcon(size === SizeClass.CUSTOM_CLASS ? null : size),
    className: className
  }), title && ___EmotionJSX("title", null, title), children);
};
export default IconBase;